import { i18nLocizeInstance } from '@influitive/locize-launcher';

const options = { defaultNs: 'FileUploader', ns: 'FileUploader' };
const i18n = i18nLocizeInstance(process.env.LOCIZE_PROJECT_ID, process.env.LOCIZE_API_KEY, options);

export default i18n;
